/**
 * Labstep
 *
 * @module components/UserGroup/List/Preview
 * @desc A list of 3 groups + View all + Plus button to create new one
 */

import { GroupItem } from 'labstep-web/components/Group/Item';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { Link } from 'labstep-web/core/Link';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Group } from 'labstep-web/models/group.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import { params } from './params';
import styles from './styles.module.scss';
import type {
  ChildrenProps,
  UserGroupListPreviewProps,
} from './types';

export const UserGroupListPreview: React.FC<
  UserGroupListPreviewProps
> = ({ activeGroup, setActiveGroupId, history }) => (
  <div className={styles.container}>
    <div>
      <ReadOnMountHOC
        type="cursor"
        entityName="user_group"
        params={params}
        pagination={{
          loader: false,
          showMore: false,
          infinite: false,
        }}
      >
        {({ entities: userGroups }: ChildrenProps) => (
          <>
            {userGroups
              .filter(
                (userGroup) =>
                  userGroup.group &&
                  !userGroup.deleted_at &&
                  userGroup.group.id !== activeGroup!.id,
              )
              .map((userGroup) => (
                <div
                  key={userGroup.id}
                  className={styles.dropdownItem}
                >
                  <div
                    style={{
                      cursor: 'pointer',
                      color: 'rgb(0, 91, 204)',
                    }}
                    onClick={() => {
                      setActiveGroupId(userGroup.group.id);
                      history.push(
                        navigation.get('group_show', {
                          id: userGroup.group.id,
                        }),
                      );
                    }}
                  >
                    <GroupItem group={userGroup.group} />
                  </div>
                </div>
              ))}
          </>
        )}
      </ReadOnMountHOC>
    </div>
    <div className={styles.all}>
      <Link to="group_index">
        All {getHumanReadableEntityName(Group.entityName, true, true)}
      </Link>
    </div>
  </div>
);

export default withRouter(withActiveGroup(UserGroupListPreview));
